import { createFileRoute } from '@tanstack/react-router'
import SuportePage from '@/pages/suporte-page'

export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/suporte',
)({
  component: SuportePage,
})

